const focusableSelector =
  'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]';

export default focusableSelector;
